<div class="offline-header">
  {{ 'general_offlineMode' | translate }}
</div>
